import clsx from 'clsx';
import React from 'react';

const layoutWrapper = "_layout-wrapper_1tfim_1";
const styles = {
	layoutWrapper: layoutWrapper
};

const PageLayout = ({ children, className, style }) => {
  return React.createElement("div", { className: clsx(styles.layoutWrapper, className), "data-zds": true, style }, children);
};

export { PageLayout };
//# sourceMappingURL=PageLayout.es.js.map
